// ANCHOR React
import React from 'react';

// ANCHOR Utils
import { ITab } from '@lyon/components/utils/ContentTabs';

// ANCHOR Components
import { LyonUpdateFormSidebarOutlineTab } from './LyonUpdateFormSidebarOutlineTab';
import { LyonUpdateFormSidebarOptionTab } from './LyonUpdateFormSidebarOptionTab';

export const TABS: ITab[] = [
  {
    key: 'questions',
    title: 'Questions',
    tabContent: <LyonUpdateFormSidebarOutlineTab />,
  },
  {
    key: 'options',
    title: 'Settings',
    tabContent: <LyonUpdateFormSidebarOptionTab />,
  },
];
